import { useCallback } from 'react'

import { useUpdateUserProfile, BookkeepingTaxRegimeId } from '@scouts/bookkeeping'

import { featureFlags } from '@/feature-flags'
import { SubscriptionTaxRegimes } from '@/models'
import { useUpdateSubscriptionTaxRegime } from '@/store/subscription'

export const useUpdateTaxRegime = () => {
    const { updateUserProfile } = useUpdateUserProfile()
    const { updateSubscriptionTaxRegime } = useUpdateSubscriptionTaxRegime()

    const updateBookkeepingTaxRegime = useCallback(
        (isUpdatedAddressCanaryIslands: boolean) =>
            updateUserProfile({
                taxRegimeId: isUpdatedAddressCanaryIslands
                    ? BookkeepingTaxRegimeId.CanaryIslands
                    : BookkeepingTaxRegimeId.Default,
            }),
        [updateUserProfile]
    )

    const updateBillingTaxRegime = useCallback(
        (isUpdatedAddressCanaryIslands: boolean) =>
            updateSubscriptionTaxRegime({
                taxRegime: isUpdatedAddressCanaryIslands
                    ? SubscriptionTaxRegimes.CanaryIslands
                    : SubscriptionTaxRegimes.Standard,
            }),
        [updateSubscriptionTaxRegime]
    )

    const updateTaxRegime = useCallback(
        (isUpdatedAddressCanaryIslands: boolean) => {
            if (!featureFlags.featureEnableCanaryIsland) return Promise.resolve()

            return Promise.all([
                updateBookkeepingTaxRegime(isUpdatedAddressCanaryIslands),
                updateBillingTaxRegime(isUpdatedAddressCanaryIslands),
            ]).then(() => {})
        },
        [updateBillingTaxRegime, updateBookkeepingTaxRegime]
    )

    return {
        updateTaxRegime,
    }
}
